import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import { Col, Row } from "reactstrap";

import { useTranslation } from "react-i18next";

import FilesCustom from 'components/FilesCustom';


export default function FilesFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [files, setFiles] = React.useState([]);
    const [rerender, setRerender] = React.useState(false);

    var filesSite = modelFctManager.appProps?.getSite();

    console.debug(files);

    return <Col><FilesCustom className="generateDlg-files" title={t("gal_attachedFiles")} bindID={(filesSite?.idSite || 0)} checkRights={modelFctManager.checkRights} fileTypeID={data.argumentsObj?.fileTypeID || "SITE"} src={null} srcName={""}
        files={files} setFiles={(compFiles) => {
            console.debug(compFiles.length);
            console.debug(compFiles);
            setFiles(compFiles);
            setRerender(!rerender);

        }} altFilesTypes="../api/site/GetSiteFilesType" altUploadFilesUrl="../api/site/UploadSiteFiles" accept={data.argumentsObj?.accept || { "text/csv": [".csv"] }} noChooseTypes={true} minFiles={data.argumentsObj?.minFiles || 2} uploadAutoClose={false} resetAfterUpload={false}
        noUploads={data.argumentsObj?.noUploads} onlyUpload={!data.argumentsObj?.fullFiles} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={data.argumentsObj?.fileType || "CTG"} maxFiles={data.argumentsObj?.maxFiles || 2} /></Col>;

}